import { render, staticRenderFns } from "./RsaPazienteTeleconsultoPage.vue?vue&type=template&id=cca4c430"
import script from "./RsaPazienteTeleconsultoPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteTeleconsultoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports